import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
var firebase = require("firebase/app")
import store from "@/store";

Vue.use(VueRouter)

	const beforeEnter = (to, from, next) => {
		if (store.state.authModule.logged) {
			next({ path: "/admin" });
		} else {
			next();
		}
	};

  const routes = [
	// Inicial	
  {
    path: '/',
    name: 'Index',
			component: () => import('../views/Welcome.vue'),
			beforeEnter: (to, from, next) => beforeEnter(to, from, next),
	},
  {
    path: '/welcome/',
    name: 'Welcome',
			component: () => import(/* webpackChunkName: "welcome" */ '../views/Welcome.vue'),
			beforeEnter: (to, from, next) => beforeEnter(to, from, next),
	},

	// App publica
	{
		path: '/basic/:id',
		name: 'Basic',
		component: Home,
	},
	{
		path: '/i/:id',
		name: 'Home',
		component: Home,
	},
	{
		path: '/i/:id/cart-list/:cat',
		name: 'CartList',
		component: () => import(/* webpackChunkName: "cartList" */ '../views/CartList.vue')
	},
	{
		path: '/i/:id/about',
		name: 'About',
		component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
	},
	{
		path: '/i/:id/splash',
		name: 'Splash',
		component: () => import(/* webpackChunkName: "splash" */ '../views/Splash.vue')
	},


	// Webs

	{
		path: '/w/:id?',
		name: 'Web',
		component: () => import(/* webpackChunkName: "site" */ '../views/Simple.vue')
	},
	{
		path: '/simple/:id?',
		name: 'Simple',
		component: () => import(/* webpackChunkName: "site" */ '../views/Simple.vue')
	},

	{
		path: '/l/:id?',
		name: 'Landng',
		component: () => import(/* webpackChunkName: "landing" */ '../views/Landing.vue')
	},
	{
		path: '/web/:id?',
		name: 'LandngWeb',
		component: () => import(/* webpackChunkName: "landing" */ '../views/Landing.vue')
	},

	// Test

	{
		path: '/i/:id/share/',
		name: 'Share',
				component: () => import(/* webpackChunkName: "share" */ '../views/Share.vue')
		},

  {
    path: '/item',
    name: 'Item',
		component: () => import(/* webpackChunkName: "itemShow" */ '../views/ItemShow.vue'),
	},

	
	// Ingreso Superadmin


  {
		path: '/login',
    name: 'Login',
		component: () => import(/* webpackChunkName: "Login" */ '../views/admin/Login.vue'),
		beforeEnter: (to, from, next) => beforeEnter(to, from, next),
	},
	{
		path: "/admin",
		name: "AdminDashboard",
		component: () =>
			import(
						/* webpackChunkName: "dashboard" */ "../views/admin/Dashboard.vue"
			),
		meta: { requiresAuth: true, title: "Escritorio Administrativo" },
		children: [

			{
				path: "clientes",
				name: "AdminCustomer",
				component: () =>
					import(
								/* webpackChunkName: "customer" */ "@/views/admin/Customer.vue"
					),
				meta: { role: "admin", title: "Clientes" },
			},
			{
				path: "negocios",
				name: "AdminBusiness",
				component: () =>
					import(
								/* webpackChunkName: "business" */ "@/views/admin/Business.vue"
					),
				meta: { role: "admin", title: "Negocios" },
			},
			{
				path: ":business_id/:business_name/categories",
				name: "AdminCategories",
				component: () =>
					import(
								/* webpackChunkName: "categories" */ "@/views/admin/Categories.vue"
					),
				meta: { role: "admin", title: "Negocios" },
			},
			{
				path: ":business_id/:business_name/:category_id/:category_name/:category_subtitle?/items",
				name: "AdminItems",
				component: () =>
					import(
								/* webpackChunkName: "items" */ "@/views/admin/Items.vue"
					),
				meta: { role: "admin", title: "Items" },
			},

		]
	},

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
	const lockedRoute = to.matched.some(record => record.meta.requiresAuth);
	const user = firebase.auth().currentUser;
	if (lockedRoute === true && user === null) {
		next({ name: 'Login' })
	} else {
		next()
	}
})

export default router
